import { Box, Button, FormControl, IconButton, Input, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import Papa from 'papaparse';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../utility/Loader';
// import your JSON templates
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import JsonViewerDialog from '../../../components/DataPipeline/JsonViewerDialog';
import { GameCssStyles } from '../../../components/GameManagement/GameCssStyles';
import api_service from '../../../network/api_callbacks';
import BatchDetailsDialog from './BatchDetailsDialog';
import UploadProgressLoader from '../UploadImage/UploadProgressLoader';
import {
    actor_ee_json_csv,
    actoress_ee_json_csv,
    cricketer_ee_json_csv,
    default_ee_json_csv,
    entity_vimeo_playable_URL_csv,
    formatDateTime,
    influencers_ee_json_csv,
    movie_ee_json_csv,
    music_director_ee_json_csv,
    question_bank_2_csv,
    rap_housie_game_csv,
    rap_real_fantasy_league_game_csv,
    rap_real_fantasy_league_game_stats_csv_allRounder,
    rap_real_fantasy_league_game_stats_csv_batsman,
    rap_real_fantasy_league_game_stats_csv_bowler,
    rap_real_fantasy_league_game_stats_csv_influencers,
    rap_real_fantasy_league_game_stats_csv_movie,
    rap_real_fantasy_league_game_stats_csv_reel,
    rap_real_fantasy_league_game_stats_csv_song,
    rap_real_fantasy_league_game_stats_csv_video,
    reel_ee_json_csv,
    song_ee_json_csv,
    timestampToMilliseconds,
    timestampToMilliseconds2,
    unknown_content_id_mapping_csv,
    video_ee_json_csv
} from './CSV_Constants';
import { extractVimeoId, getVimeoPlayLink } from '../../../network/vimeo_network_service/Vimeo_api_callback';
import JSZip from 'jszip';

function UploadCSV(props) {

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const state = location.state;
    const [loader, setLoader] = useState(false);

    const [openViewJSONDialog, setOpenViewJSONDialog] = useState(false);
    const [openBatchDetailsDialog, setOpenBatchDetailsDialog] = useState(false);
    const [selectedCSVType, setSelectedCSVType] = useState('');
    const [csvData, setCsvData] = useState([]);
    const [fileName, setFileName] = useState('');
    const [mappedData, setMappedData] = useState([]);
    const [latestBatchList, setLatestBatchList] = useState(null);

    const [specificBatchDetail, setSpecificBatchDetail] = useState(null);
    const [specificCompletedBatches, setSpecificCompletedBatches] = useState([]);
    const [specificPendingBatches, setSpecificPendingBatches] = useState([]);
    const [folderUploading, setFolderUploading] = useState(false);
    const [selectedFolderName, setSelectedFolderName] = useState('');
    const [totalFiles, setTotalFiles] = useState(0);
    const [uploadedFiles, setUploadedFiles] = useState(0);
    const [currentFileName, setCurrentFileName] = useState('');

    useEffect(() => {
        if (latestBatchList === null) {
            getCsvBatchListApi();
        }
    }, [])

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setFileName(file.name);
        setLoader(true);

        if (selectedCSVType === 'Entity') {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonEntity(results);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === 'Submit Stats') {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonStats(results);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === 'Rap Fantasy League Game') {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonFantasyLeague(results);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === 'Rap Housie Game') {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonHousie(results);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === 'Open Source Question Bank') {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonOpenSourceQuestionBank(results);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === "Shemaroo Entity Sheet - SHM" || selectedCSVType === "Shemaroo Entity Sheet - SHA" || selectedCSVType === "Shemaroo Entity Sheet - SHV") {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonShemarooEntitySheet(results, selectedCSVType);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === "Entity Vimeo Playable URL") {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    csvToJsonEntityVimeoPlayableURLSheet(results);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else if (selectedCSVType === "Unknown Content ID Mapping") {
            Papa.parse(file, {
                encoding: "UTF-8",
                header: true,
                skipEmptyLines: true,
                complete: function (result) {
                    csvToJsonUnknownContentIDMapping(result);
                },
                error: function (err) {
                    console.error('CSV parse error:', err);
                    setLoader(false);
                },
            });
        }
        else {

        }
        e.target.value = null;
    }

    const csvToJsonUnknownContentIDMapping = (result) => {
        // drop the first 2 rows
        const cleaned = result?.data?.slice(0);

        setCsvData(cleaned);
        setLoader(false);
        console.log('CSV Data (skipped 1 rows):', cleaned);
        // map CSV rows into schemas
        const mapped = cleaned.map((row) => mapRowToSchemaUnknownContentIDMapping(row));

        pushImportCSVApiUnknownContentIDMapping(mapped);
        setMappedData(mapped);
        console.log('Mapped Data:', mapped);
    }

    const mapRowToSchemaUnknownContentIDMapping = (row) => {
        // Sanitize all row fields: if value is '#N/A' or 'Not Found', use empty string
        const sanitizedRow = {};
        Object.entries(row).forEach(([k, v]) => {
            if (typeof v === 'string' && (v.trim() === '#N/A' || v.trim() === 'Not Found')) {
                sanitizedRow[k] = '';
            } else {
                sanitizedRow[k] = v;
            }
        });
        let template = {};
        template = JSON.parse(JSON.stringify(unknown_content_id_mapping_csv));
        template.contentId = sanitizedRow["CONTENT ID"];
        template.url = sanitizedRow["videoUrl"];
        template.newForm = sanitizedRow["Form"];
        if (template.contentId && template.url && template.newForm) {
            template.form = 'video';
            template.type = '';
            template.aspectRatio = '16:9';
        }
        console.log('Mapped Unknown Content ID Template:', template);
        return template;
    }

    const pushImportCSVApiUnknownContentIDMapping = async (data) => {
        if (data != null && selectedCSVType) {
            setLoader(true);
            try {
                const response = await api_service.uploadContentIDSheet({ data });

                const status = response?.status;
                const resData = response?.data;
                const responseCode = response?.responseCode;
                const errorMsg = response?.error?.message;

                if (status === 201 || status === 200) {
                    toast.success(`${selectedCSVType} CSV uploaded on server.`)
                }
                else {
                    toast.error(`${selectedCSVType} - ${errorMsg}`)
                }

                console.log('📘 pushImportCSVApiOpenSourceQuestionBank response :', response);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank status :', status);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank data :', resData);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank responseCode :', responseCode);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank errorMsg :', errorMsg);
                getCsvBatchListApi();
                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch pushImportCSVApiUnknownContentIDMapping:', error);
            }
        }
    }

    const getCsvBatchListApi = async () => {
        setLoader(true);
        try {
            const response = await api_service.getCsvBatchList();

            const status = response?.status;
            const resData = response?.data;
            const responseCode = response?.responseCode;
            const errorMsg = response?.error?.message;

            //const latestBatch = resData?.batch;
            //const latestBatchData = resData?.data;

            console.log('📘 pushImportCSVApi response :', response);
            console.log('📘 pushImportCSVApi status :', status);
            console.log('📘 pushImportCSVApi data :', resData);
            console.log('📘 pushImportCSVApi responseCode :', responseCode);
            console.log('📘 pushImportCSVApi errorMsg :', errorMsg);
            //console.log('📘 pushImportCSVApi latestBatch :', latestBatch);
            //console.log('📘 pushImportCSVApi latestBatchData :', latestBatchData);

            setLatestBatchList(resData);
            //setLatestBatchData(latestBatchData);
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error('❌ Failed to fetch getResultCSV:', error);
        }
    }

    const getCsvBatchItemDetail = async (batchId) => {
        setLoader(true);
        try {
            const response = await api_service.getCsvBatchDetail({ batchId });

            const status = response?.status;
            const resData = response?.data;
            const responseCode = response?.responseCode;
            const errorMsg = response?.error?.message;

            const specificBatchDetail = resData?.batch;

            const allBatches = resData?.data || [];

            const normalizeStatus = (s) => (s ?? '').toString().trim().toLowerCase();

            const specificBatchSuccessData = allBatches.filter(
                (item) => normalizeStatus(item?.status) === 'complete'
            );

            const specificBatchRestData = allBatches.filter(
                (item) => normalizeStatus(item?.status) !== 'complete'
            );

            setSpecificBatchDetail(specificBatchDetail);
            // Always replace previous batch rows so CF IDs from the selected batch are shown
            setSpecificCompletedBatches(specificBatchSuccessData);
            setSpecificPendingBatches(specificBatchRestData);

            if (specificBatchSuccessData?.length > 0 || specificBatchRestData?.length > 0) {
                setOpenBatchDetailsDialog(true);
            }

            console.log('📘 pushImportCSVApi response :', response);
            console.log('📘 pushImportCSVApi status :', status);
            console.log('📘 pushImportCSVApi data :', resData);
            console.log('📘 pushImportCSVApi responseCode :', responseCode);
            console.log('📘 pushImportCSVApi errorMsg :', errorMsg);
            console.log('📘 pushImportCSVApi specificBatchDetail :', specificBatchDetail);
            console.log('✅ Completed Batches:', specificBatchSuccessData);
            console.log('⚠️ Pending Batches:', specificBatchRestData);
            //console.log('📦 Rest (non-complete) Batches:', specificBatchRestData);

            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error('❌ Failed to fetch getResultCSV:', error);
        }
    }

    const pushImportCSVApiEntity = async (data) => {
        if (data != null && selectedCSVType) {
            setLoader(true);
            try {
                const response = await api_service.pushImportCSVEntity({ data });

                console.log('📘 pushImportCSVApiEntity response :', response);

                const status = response?.status;
                const resData = response?.data;
                const responseCode = response?.responseCode;
                const errorMsg = response?.error?.message;

                if (status === 201 || status === 200 || responseCode === 200 || responseCode === 201) {
                    toast.success(`${selectedCSVType} CSV uploaded on server.`)
                }
                else {
                    toast.error(`${selectedCSVType} - ${errorMsg}`)
                    console.log('Returning responseCode due to error:', responseCode);
                    return responseCode;
                }

                console.log('📘 pushImportCSVApiEntity response :', response);
                console.log('📘 pushImportCSVApiEntity status :', status);
                console.log('📘 pushImportCSVApiEntity data :', resData);
                console.log('📘 pushImportCSVApiEntity responseCode :', responseCode);
                console.log('📘 pushImportCSVApiEntity errorMsg :', errorMsg);
                getCsvBatchListApi();
                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch pushImportCSVApiEntity:', error);
            }
        }
    }

    const pushImportCSVApiFantasy = async (data) => {
        if (data != null && selectedCSVType) {
            setLoader(true);
            try {
                const response = await api_service.pushImportCSVFantasy({ data });

                const status = response?.status;
                const resData = response?.data;
                const responseCode = response?.responseCode;
                const errorMsg = response?.error?.message;

                if (status === 201 || status === 200) {
                    toast.success(`${selectedCSVType} CSV uploaded on server.`)
                }
                else {
                    toast.error(`${selectedCSVType} - ${errorMsg}`)
                }

                console.log('📘 pushImportCSVApi response :', response);
                console.log('📘 pushImportCSVApi status :', status);
                console.log('📘 pushImportCSVApi data :', resData);
                console.log('📘 pushImportCSVApi responseCode :', responseCode);
                console.log('📘 pushImportCSVApi errorMsg :', errorMsg);
                getCsvBatchListApi();
                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch pushImportCSVApi:', error);
            }
        }
    }

    const pushImportCSVApiFantasyStats = async (data) => {
        if (data != null && selectedCSVType) {
            setLoader(true);
            try {
                const response = await api_service.pushImportCSVFantasyStats({ data });

                const status = response?.status;
                const resData = response?.data;
                const responseCode = response?.responseCode;
                const errorMsg = response?.error?.message;

                if (status === 201 || status === 200) {
                    toast.success(`${selectedCSVType} CSV uploaded on server.`)
                }
                else {
                    toast.error(`${selectedCSVType} - ${errorMsg}`)
                }

                console.log('📘 pushImportCSVApiFantasyStats response :', response);
                console.log('📘 pushImportCSVApiFantasyStats status :', status);
                console.log('📘 pushImportCSVApiFantasyStats data :', resData);
                console.log('📘 pushImportCSVApiFantasyStats responseCode :', responseCode);
                console.log('📘 pushImportCSVApiFantasyStats errorMsg :', errorMsg);
                getCsvBatchListApi();
                setLoader(false);
            } catch (error) {
                setLoader(false);
            }
        }
    }

    const pushImportCSVApiHousie = async (data) => {
        if (data != null && selectedCSVType) {
            setLoader(true);
            try {
                const response = await api_service.pushImportCSVHousie({ data });

                const status = response?.status;
                const resData = response?.data;
                const responseCode = response?.responseCode;
                const errorMsg = response?.error?.message;

                if (status === 201 || status === 200) {
                    toast.success(`${selectedCSVType} CSV uploaded on server.`)
                }
                else {
                    toast.error(`${selectedCSVType} - ${errorMsg}`)
                }

                console.log('📘 pushImportCSVApiHousie response :', response);
                console.log('📘 pushImportCSVApiHousie status :', status);
                console.log('📘 pushImportCSVApiHousie data :', resData);
                console.log('📘 pushImportCSVApiHousie responseCode :', responseCode);
                console.log('📘 pushImportCSVApiHousie errorMsg :', errorMsg);
                getCsvBatchListApi();
                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch pushImportCSVApiHousie:', error);
            }
        }
    }

    /**
    * Collect all values for a base key from a parsed CSV row
    * Handles duplicates like genre, genre_1, genre_2, ...
    * @param {Object} row - CSV row object
    * @param {string} baseKey - base key to collect (e.g., "genre")
    * @param {boolean} removeEmpty - optional, remove empty strings (default: true)
    * @returns {Array} - array of values
    */
    function collectDuplicateKeys(row, baseKey, removeEmpty = true) {
        const values = Object.keys(row)
            .filter(key => key === baseKey || key.startsWith(`${baseKey}_`))
            .map(key => row[key]);

        return removeEmpty ? values.filter(val => val !== '' && val !== null && val !== undefined) : values;
    }

    // Split a semicolon-separated string and return array of trimmed values
    const splitSemicolonArray = (inputString) => {
        if (!inputString || typeof inputString !== 'string') return [];
        return inputString
            .split(';')
            .map(val => val.trim())
            .filter(val => val);
    };

    const normalizeCsvHeader = (header = '') => String(header).toLowerCase().replace(/[^a-z0-9]/g, '');

    const getCsvField = (row, aliases = []) => {
        if (!row || typeof row !== 'object') return '';
        for (const alias of aliases) {
            const direct = row[alias];
            if (direct != null && String(direct).trim() !== '') return String(direct);
        }
        const aliasSet = new Set(aliases.map(normalizeCsvHeader));
        for (const [key, value] of Object.entries(row)) {
            if (aliasSet.has(normalizeCsvHeader(key)) && value != null && String(value).trim() !== '') {
                return String(value);
            }
        }
        return '';
    };

    const parseTagField = (raw) => splitSemicolonArray(String(raw ?? '').split(',').join(';'));

    const CONTENT_TAG_ALIASES = [
        'content_tag', 'content_tags', 'CONTENT_TAG', 'CONTENT_TAGS',
        'content tag', 'content tags', 'TAGS', 'Tags', 'tags', 'Tag', 'tag'
    ];
    const LOCATION_TAG_ALIASES = ['location_tag', 'location_tags', 'LOCATION_TAG', 'LOCATION_TAGS', 'location tag', 'location tags'];
    const LANGUAGE_TAG_ALIASES = ['language_tag', 'language_tags', 'LANGUAGE_TAG', 'LANGUAGE_TAGS', 'language tag', 'language tags'];
    const QUESTION_BANK_DIFFICULTIES = ['Easy', 'Medium', 'Difficult'];
    const QUESTION_BANK_OPTION_LETTERS = ['A', 'B', 'C', 'D'];
    const QUESTION_BANK_GAME_TYPES = ['RF', 'RW'];

    const cleanCsvCell = (value) => String(value ?? '').replace(/^\uFEFF/, '').trim();

    const isQuestionBankHeaderRow = (row) => {
        const first = Array.isArray(row) ? row[0] : row?.['CONTENT ID'];
        return cleanCsvCell(first).toLowerCase() === 'content id';
    };

    const parseGameTypeTokens = (value) => {
        return String(value ?? '')
            .split(/[;,]/)
            .map(v => v.trim())
            .filter(v => QUESTION_BANK_GAME_TYPES.includes(v));
    };

    // Google-sheet QB exports often leave OPTIONS / GAME TYPE / tags unquoted, so
    // commas inside those cells shift every later column. Rebuild fields from
    // known sentinels (difficulty, A-D, RF/RW) instead of header positions.
    const reconstructOpenSourceQuestionBankRow = (row) => {
        const cells = (Array.isArray(row) ? row : Object.values(row || {}))
            .map(cleanCsvCell);

        while (cells.length && cells[cells.length - 1] === '') {
            cells.pop();
        }
        if (!cells.length) return null;

        const contentId = cells[0] || '';
        const entityName = cells[1] || '';
        const entityType = cells[2] || '';
        const questionText = cells[3] || '';
        const rest = cells.slice(4);
        const diffIdx = rest.findIndex(v => QUESTION_BANK_DIFFICULTIES.includes(v));

        if (diffIdx === -1) {
            return {
                "CONTENT ID": contentId,
                ENTITY: entityName,
                "ENTITY TYPE": entityType,
                QUESTIONS: questionText,
                OPTIONS: rest[0] || '',
                ANSWER: rest[1] || '',
                OPTION_NUMBER: rest[2] || '',
                DIFFICULTY: rest[3] || '',
                "GAME TYPE": rest[4] || '',
                content_tag: rest[5] || '',
                SOURCE: rest[6] || '',
            };
        }

        const optionsPart = rest.slice(0, diffIdx);
        let optionNumber = '';
        let answer = '';
        if (optionsPart.length && QUESTION_BANK_OPTION_LETTERS.includes(optionsPart[optionsPart.length - 1])) {
            optionNumber = optionsPart.pop();
        }
        if (optionsPart.length) {
            answer = optionsPart.pop();
        }

        let optionsValue = '';
        if (optionsPart.length === 1) {
            optionsValue = optionsPart[0].includes(';')
                ? optionsPart[0]
                : optionsPart[0].split(',').map(s => s.trim()).filter(Boolean).join(';');
        } else {
            optionsValue = optionsPart.join(';');
        }

        const afterDiff = rest.slice(diffIdx + 1);
        const gameTypes = [];
        let cursor = 0;
        while (cursor < afterDiff.length) {
            const tokens = parseGameTypeTokens(afterDiff[cursor]);
            const rawParts = String(afterDiff[cursor]).split(/[;,]/).map(s => s.trim()).filter(Boolean);
            if (tokens.length && tokens.length === rawParts.length) {
                gameTypes.push(...tokens);
                cursor += 1;
            } else {
                break;
            }
        }

        const remaining = afterDiff.slice(cursor);
        let source = '';
        let tagParts = remaining;
        if (remaining.length && remaining[remaining.length - 1].toLowerCase() === 'manual') {
            source = remaining[remaining.length - 1];
            tagParts = remaining.slice(0, -1);
        }

        const contentTag = tagParts.filter(Boolean).join(';');
        return {
            "CONTENT ID": contentId,
            ENTITY: entityName,
            "ENTITY TYPE": entityType,
            QUESTIONS: questionText,
            OPTIONS: optionsValue,
            ANSWER: answer,
            OPTION_NUMBER: optionNumber,
            DIFFICULTY: rest[diffIdx],
            "GAME TYPE": gameTypes.join(';'),
            content_tag: contentTag,
            TAGS: contentTag,
            SOURCE: source,
        };
    };

    // Replace semicolons and newlines with comma, remove trailing commas/spaces
    const formattedString = (inputString) => {
        //const value = collectDuplicateKeys(inputString) || '';
        return inputString?.split(/;\n?/)       // split by ";" optionally followed by "\n"
            .map(name => name?.trim())  // remove extra spaces
            .filter(name => name)      // remove empty strings
            .join(', ');               // join with comma
    }

    const csvToJsonEntityVimeoPlayableURLSheet = async (results) => {
        // drop the first 2 rows
        const cleaned = results.data.slice(0);

        setCsvData(cleaned);
        setLoader(false);
        console.log('CSV Data (skipped 2 rows):', cleaned);

        // map CSV rows into schemas
        const mapped = await Promise.all(cleaned.map((row) => mapRowToSchemaEntityVimeoPlayableURLSheet(row)));

        console.log('Mapped Data:', mapped);


        const headers = [
            "Content ID",
            "Content URL",
            "Content Playable URL",
            "Video Duration",
            "Video Preview Image"
        ];

        const rows = mapped?.map((batch) => [
            batch?.ContentID || "",
            batch?.ContentURL || "",
            batch?.vimeoPlayableURL || "",
            batch?.duration || "",
            batch?.previewImage || ""
        ]);

        const csvContent = [
            headers?.join(","),
            ...rows?.map((r) => r?.map((v) => `"${String(v)?.replace(/"/g, '""')}"`)?.join(",")),
        ]?.join("\n");

        console.log('CSV Content to be uploaded:\n', csvContent);

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Create timestamp in dd_mm_yy_HH_mm format
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yy = String(now.getFullYear()).slice(-2);
        const HH = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}_${mm}_${yy} ${HH}_${min}`;
        link.download = `Entity Vimeo Playable URL ${timestamp}.csv`;
        link.click();

        URL.revokeObjectURL(url);
    }

    const mapRowToSchemaEntityVimeoPlayableURLSheet = async (row) => {
        let template = {};
        template = JSON.parse(JSON.stringify(entity_vimeo_playable_URL_csv));
        template.ContentID = row['Content ID'] || row['CONTENT ID'] || row['Unique ID'] || '';
        template.ContentURL = row['Content URL'] || row['URL'] || '';
        template.vimeoPlayableURL = '';
        template.duration = '';
        template.previewImage = '';

        const vimeoUrl = template.ContentURL || '';
        const vimeoId = extractVimeoId(vimeoUrl);

        if (!vimeoId) {
            console.error(`Invalid Vimeo URL: ${vimeoUrl}`);
            return template;
        }

        const videoInfo = await getVimeoPlayLink(vimeoId);

        if (!videoInfo) {
            console.error(`No playable Vimeo link found for video ID: ${vimeoId}`);
            return;
        }

        const { progressiveLink, playLink, videoData } = videoInfo;
        const title = videoData?.name;
        const duration = videoData?.duration;
        const image = videoData?.pictures?.base_link;

        template.vimeoPlayableURL = progressiveLink || '';
        template.duration = duration || '';
        template.previewImage = image || '';

        return template;
    }

    const csvToJsonShemarooEntitySheet = (result, selectedCSVType) => {
        // drop the first 2 rows
        const cleaned = result?.data?.slice(0);

        setCsvData(cleaned);
        setLoader(false);
        console.log('CSV Data (skipped 1 rows):', cleaned);

        // --- Create an entity map for merging ---
        const entityMap = new Map();

        const keyField =
            selectedCSVType === "Shemaroo Entity Sheet - SHM"
                ? "Movie Name"
                : selectedCSVType === "Shemaroo Entity Sheet - SHA"
                    ? "Tracks Name"
                    : selectedCSVType === "Shemaroo Entity Sheet - SHV"
                        ? "Track Name"
                        : null;

        if (!keyField) {
            console.error("Unknown CSV type for mapping");
            return;
        }

        console.log('selectedCSVType:', selectedCSVType);
        console.log('keyField:', keyField);

        cleaned.forEach((row) => {
            const entityKey = row[keyField]?.trim();
            if (!entityKey) return;

            // Extract multimedia from the row only
            const rowMultimedia = (selectedCSVType === "Shemaroo Entity Sheet - SHM")
                ? (mapRowToSchemaShemarooEntitySheetSHM(row, selectedCSVType).multimedia || [])
                : (mapRowToSchemaShemarooEntitySheetSHA(row, selectedCSVType).multimedia || []);

            if (!entityMap.has(entityKey)) {
                // First occurrence: map the full row
                const mappedRow = (selectedCSVType === "Shemaroo Entity Sheet - SHM")
                    ? mapRowToSchemaShemarooEntitySheetSHM(row, selectedCSVType)
                    : mapRowToSchemaShemarooEntitySheetSHA(row, selectedCSVType);

                entityMap.set(entityKey, mappedRow);
            } else {
                // Entity exists: just append new multimedia URLs
                const existing = entityMap.get(entityKey);
                const mergedMultimedia = [...(existing.multimedia || []), ...rowMultimedia];

                // Remove duplicates by URL
                existing.multimedia = mergedMultimedia.filter(
                    (item, index, self) => index === self.findIndex(t => t.url === item.url)
                );

                entityMap.set(entityKey, existing);
            }
        });

        // Convert map → array
        const mergedEntities = Array.from(entityMap.values());

        console.log("✅ Merged Entities:", mergedEntities);

        pushImportCSVApiEntity(mergedEntities);
        setMappedData(mergedEntities);
        console.log('Mapped Data:', mergedEntities);
    }

    const mapRowToSchemaShemarooEntitySheetSHM = (row, selectedCSVType) => {
        let template = {};
        template = JSON.parse(JSON.stringify(movie_ee_json_csv));
        template.entityName = row['Movie Name'];
        template.entityCategory = 'movie';
        // template.entitySubCategory = '';
        template.displayImageUrl = row.displayImageUrl || '';
        template.triviaCard.common.director = formattedString(row['Director(s)']) || '';
        template.triviaCard.housie.actors = formattedString(row['Star Cast']) || '';
        template.triviaCard.housie.awardsWon = '';
        template.triviaCard.housie.yearOfRelease = formattedString(row['YEAR']) || '';
        template.triviaCard.fantasy.genre = formattedString(row['Genre']) || '';
        template.triviaCard.fantasy.language = formattedString(row['Language']) || '';
        template.triviaCard.fantasy.producer = '';
        template.triviaCard.fantasy.productionHouse = '';
        template.triviaCard.fantasy.leadCast = '';
        template.triviaCard.fantasy.releaseDate = '';
        template.triviaCard.transient.averageWeeklyCollection = '';
        template.triviaCard.transient.totalCollection = '';

        const multimedia = [];

        if (row['URL']) {
            multimedia.push({
                contentId: row['Content ID'] || row['Unique ID'],
                form: 'video',
                type: '',
                url: row['URL'].trim(),
                aspectRatio: row['Aspect Ratio'] || '16:9'
            });
        }

        template.multimedia = multimedia;

        return template;
    }

    const mapRowToSchemaShemarooEntitySheetSHA = (row, selectedCSVType) => {
        let template = {};
        template = JSON.parse(JSON.stringify(song_ee_json_csv));
        template.entityName = row['Tracks Name'] || row['Track Name'];
        template.entityCategory = 'song';
        // template.entitySubCategory = '';
        template.displayImageUrl = row.displayImageUrl || '';
        template.triviaCard.common.musicDirector = (formattedString(row['Director']) + formattedString(row['Producer'])) || formattedString(row['Director(s)']) || '';
        template.triviaCard.common.movie = formattedString(row['Album Name']) || formattedString(row['Movie']) || '';
        template.triviaCard.housie.actor_actress = (formattedString(row['Actors']) + formattedString(row["Actress"])) || formattedString(row['Star Cast']) || '';
        template.triviaCard.housie.yearOfRelease = formattedString(row['YOR']) || formattedString(row['YEAR']) || '';
        template.triviaCard.housie.majorAwards = '';
        template.triviaCard.fantasy.title = row['Tracks Name'] || row['Track Name'] || '';
        template.triviaCard.fantasy.album = formattedString(row['Album Name']) || formattedString(row['Movie']) || '';
        template.triviaCard.fantasy.singers = formattedString(row['Singers']) || formattedString(row['Singer']) || '';
        template.triviaCard.fantasy.composer = '';
        template.triviaCard.fantasy.genre = formattedString(row['Genre']) || '';        //extra
        template.triviaCard.fantasy.musicDirector = formattedString(row['Music Director']) || '';
        template.triviaCard.fantasy.lyricist = formattedString(row['Lyrics']) || formattedString(row['Lyricist']) || '';
        template.triviaCard.transient.last3releasesAverageStreams = '';
        template.triviaCard.transient.currentNumberofStreams = '';
        template.triviaCard.transient.positionOnTheplaylist = '';
        template.triviaCard.transient.spotifyStats = '';
        const multimedia = [];

        if (row['URL']) {
            multimedia.push({
                contentId: row['Content ID'] || row['Unique ID'],
                form: selectedCSVType === 'Shemaroo Entity Sheet - SHA' ? 'audio' : 'video',
                type: '',
                url: row['URL'].trim(),
                aspectRatio: row['Aspect Ratio'] || ''
            });
        }

        template.multimedia = multimedia;
        return template;
    }

    const mapRowToSchemaShemarooEntitySheetSHV = (row) => {
        let template = {};
        template = JSON.parse(JSON.stringify(video_ee_json_csv));
        template.entityName = row['Track Name'];
        template.entityCategory = 'video';
        template.entitySubCategory = '';
        template.displayImageUrl = row.displayImageUrl || '';
        template.triviaCard.common.title = formattedString(row['Track Name']) || formattedString(row.title_1) || formattedString(row.title_2) || formattedString(row.title_3) || '';
        template.triviaCard.common.creatorName = formattedString(row.creatorName) || formattedString(row.creatorName_1) || '';
        template.triviaCard.common.channelName = formattedString(row.channelName) || '';
        template.triviaCard.common.releaseDate = formattedString(row.releaseDate) || formattedString(row.releaseDate_1) || '';
        template.triviaCard.common.genre = formattedString(row.genre) || formattedString(row.genre_1) || formattedString(row.genre_2) || formattedString(row.genre_3) || '';
        template.triviaCard.common.artists = formattedString(row.artists) || '';
        template.triviaCard.housie = {};
        template.triviaCard.fantasy = {};
        template.triviaCard.transient.trendingListPosition = formattedString(row.trendingListPosition) || '';
        template.triviaCard.transient.totalViews = formattedString(row.totalViews) || '';
        template.triviaCard.transient.totalChannelSubscribers = formattedString(row.totalChannelSubscribers) || '';
        return template;
    }

    const csvToJsonOpenSourceQuestionBank = (result) => {
        const rawRows = result?.data || [];
        const startIdx = isQuestionBankHeaderRow(rawRows[0]) ? 1 : 0;
        const cleaned = rawRows
            .slice(startIdx)
            .map(reconstructOpenSourceQuestionBankRow)
            .filter(row => row && Object.values(row).some(v => String(v ?? '').trim() !== ''));

        setCsvData(cleaned);
        setLoader(false);
        console.log('CSV Data (skipped 1 rows):', cleaned);

        // map CSV rows into schemas
        let errors = [];

        const resultSheets = [];
        const mappedWithValidity = cleaned.map(row => mapRowToSchemaOpenSourceQuestionBank2(row, errors));
        console.log("mappedWithValidity:", mappedWithValidity);

        // Invalid rows are skipped; only valid questions are imported.
        const mapped = mappedWithValidity.filter(item => item && item.isvalid !== false);
        const skippedCount = mappedWithValidity.length - mapped.length;
        console.log("mapped:", mapped);
        console.log(`Skipped ${skippedCount} invalid question rows`);

        if (!mapped.length) {
            toast.error('No valid questions found in the CSV. Request was not sent.');
            setMappedData([]);
            return;
        }

        pushImportCSVApiOpenSourceQuestionBank(mapped, resultSheets);
        setMappedData(mapped);
        // Optionally, you can set errorRows in state if you want to use it elsewhere
        // setErrorRows(errorRows);
        console.log('Mapped Data:', mapped);

    }

    const mapRowToSchemaOpenSourceQuestionBank2 = (row, errors) => {
        // Sanitize all row fields: if value is '#N/A' or 'Not Found', use empty string
        const sanitizedRow = {};
        Object.entries(row).forEach(([k, v]) => {
            const value = String(v ?? '').trim();
            if (value === '#N/A' || value === 'Not Found') {
                sanitizedRow[k] = '';
            } else {
                sanitizedRow[k] = value;
            }
        });
        let template = {};
        let isvalid = true;
        template = JSON.parse(JSON.stringify(question_bank_2_csv));
        template.contentId = sanitizedRow["CONTENT ID"];
        template.entityName = sanitizedRow["ENTITY"];
        template.entityType = sanitizedRow["ENTITY TYPE"];
        template.questionText = sanitizedRow["QUESTIONS"];
        template.answer = sanitizedRow["ANSWER"];
        let options = splitSemicolonArray(sanitizedRow["OPTIONS"]);
        if (options.length !== 4) {
            const commaOptions = String(sanitizedRow["OPTIONS"] || '')
                .split(',')
                .map(val => val.trim())
                .filter(val => val);
            if (commaOptions.length === 4) {
                options = commaOptions;
            }
        }
        template.options = options;
        // Map DIFFICULTY string to number: Easy=0, Medium=1, Difficult=2
        if (sanitizedRow["DIFFICULTY"] === "Easy") {
            template.difficulty = 0;
        } else if (sanitizedRow["DIFFICULTY"] === "Medium") {
            template.difficulty = 1;
        } else if (sanitizedRow["DIFFICULTY"] === "Difficult") {
            template.difficulty = 2;
        } else {
            template.difficulty = -1;
        }
        template.gameType = splitSemicolonArray(sanitizedRow["GAME TYPE"]);     //RF,RW
        if (!template.gameType.length) {
            template.gameType = parseGameTypeTokens(sanitizedRow["GAME TYPE"]);
        }
        template.content_tag = parseTagField(getCsvField(sanitizedRow, CONTENT_TAG_ALIASES));
        template.location_tag = parseTagField(getCsvField(sanitizedRow, LOCATION_TAG_ALIASES));
        template.language_tag = parseTagField(getCsvField(sanitizedRow, LANGUAGE_TAG_ALIASES));

        // Required headers and their expected keys
        const requiredHeaders = [
            { key: "CONTENT ID", value: template.contentId },
            { key: "ENTITY", value: template.entityName },
            { key: "ENTITY TYPE", value: template.entityType },
            { key: "QUESTIONS", value: template.questionText },
            { key: "ANSWER", value: template.answer },
            { key: "OPTIONS", value: template.options },
            { key: "DIFFICULTY", value: template.difficulty },
            { key: "GAME TYPE", value: template.gameType }
        ];

        requiredHeaders.forEach(header => {
            if (header?.value === undefined || header?.value === null || String(header?.value).trim() === "") {
                errors.push(`Missing or empty field '${header?.key}' in question: ${row}`);
                isvalid = false;
            }
        });

        // Additional validations
        // 1. options length must be 4
        if (Array.isArray(template?.options) && template?.options?.length !== 4) {
            errors.push(`Options must have exactly 4 values in question: ${template?.questionText}`);
            isvalid = false;
        }

        if (Array.isArray(template?.options) && template?.options?.length === 4 && !template?.options.includes(template?.answer)) {
            errors.push(`Options must have contains correct answer in question: ${template?.questionText}`);
            isvalid = false;
        }

        // 2. difficulty must not be -1
        if (template?.difficulty === -1) {
            errors.push(`Invalid or missing DIFFICULTY in question: ${template?.questionText}`);
            isvalid = false;
        }
        // 3. gameType length must not be 0
        if (!Array.isArray(template?.gameType) || template?.gameType.length === 0) {
            errors.push(`GAME TYPE must have at least one value (RF or RW) in question: ${template?.questionText}`);
            isvalid = false;
        } else {
            // 4. gameType must contain RF or RW
            const validGameTypes = ["RF", "RW"];
            const hasValidGameType = template?.gameType.some(gt => validGameTypes.includes(gt));
            if (!hasValidGameType) {
                errors.push(`GAME TYPE must contain at least one of RF or RW in question: ${template?.questionText}`);
                isvalid = false;
            }
        }

        console.log('Mapped Question Template:', template);
        return isvalid ? template : { isvalid: false, row: row };
    }

    const mapRowToSchemaOpenSourceQuestionBank = (row) => {
        // Split tags if CSV has comma-separated string
        const tags = row["META TAGS/Form"] ? row["META TAGS/Form"].split(";").map(t => t.trim()) : [];

        // Prepare multimedia (if CSV has columns for it)
        const multimedia = row["URL"]
            ? {
                contentId: row["CONTENT ID"] || "",
                form: "video",
                type: "",
                url: row["URL"] || "",
                aspectRatio: "16:9",
            }
            : undefined;

        // Read and clean up the raw options string (from CSV)
        const rawOptions = row["OPTIONS"] || row["options"] || "";

        // Split by semicolon or newline, then trim and filter out empties
        const optionList = rawOptions
            .split(/;|\n/)
            .map(opt => opt.trim())
            .filter(Boolean);

        // Convert each option into a structured object
        const options = optionList.map((text, index) => ({
            text,
            label: "",  //String.fromCharCode(65 + index),
            multimedia: {
                url: "",
                form: "",
                type: "",
                aspectRatio: "",
            },
        }));

        const difficultyMap = {
            "Easy": "easy",
            "Medium": "medium",
            "Difficult": "hard"
        };

        const gameTypeMap = {
            "RapWheel & RapFire": ["rapFire", "rapWheel"],
            "RapFire": "rapFire",
            "RapWheel": "rapWheel"
        };

        // Final template
        const template = {
            csv_questionId: row["QUESTION ID"] || "",
            questionCategory: row["CATEGORY"] || "",
            contentId: row["CONTENT ID"] || "",
            difficulty: difficultyMap[row["DIFFICULTY"]] || "",
            entityName: row["ENTITY"] || "",
            entityType: row["ENTITY TYPE"] || "",
            // entitySubType: row["ENTITY ARTIST TYPE"] || "",
            csv_tags: tags,
            gameType: gameTypeMap[row["GAME TYPE"]] || "",
            questionText: row["QUESTIONS"] || "",
            answer: row["ANSWER"] || "",
            multimedia,
            options,
        };

        console.log('Mapped Question Template:', template);
        return template;

    }

    const pushImportCSVApiOpenSourceQuestionBank = async (data, resultSheets) => {
        if (Array.isArray(data) && data.length > 0 && selectedCSVType) {
            setLoader(true);
            try {
                const response = await api_service.pushImportCSVQuestioBank({ data });
                const envelope = response?.data && (response.data.responseCode || response.data.error)
                    ? response.data
                    : response;

                const status = envelope?.responseCode || response?.status;
                var resData = envelope?.data;

                const successResData = resData?.createdQuestionIds || [];
                const errorresData = resData?.errors || [];
                const totalQuestionCount = resData?.totalQuestionCount || 0;

                resultSheets.push({
                    name: `Total Questions.txt`,
                    content: `Total Questions in DB : ${totalQuestionCount.toString()}`
                });
                console.log('Total Questions in DB:', totalQuestionCount);


                const responseCode = envelope?.responseCode || response?.responseCode;
                const errorMsg = envelope?.error?.message || response?.data?.error?.message || response?.error?.message || response?.message;

                if (status === 201 || status === 200) {
                    toast.success(`${selectedCSVType} CSV uploaded on server.`)
                    // Download QB Result ZIP
                    downloadQBResult(data, resultSheets, errorresData, successResData);
                }
                else {
                    toast.error(`${selectedCSVType} - ${errorMsg}`)
                    // Download QB Result ZIP
                    downloadQBResult(data, resultSheets, errorresData, successResData);
                }

                console.log('📘 pushImportCSVApiOpenSourceQuestionBank response :', response);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank status :', status);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank data :', resData);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank responseCode :', responseCode);
                console.log('📘 pushImportCSVApiOpenSourceQuestionBank errorMsg :', errorMsg);
                getCsvBatchListApi();

                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error('❌ Failed to fetch pushImportCSVApiHousie:', error);
            }
        }
    }

    const downloadQBResult = (data, resultSheets, errorresData, successResData) => {
        // Add timestamp to error CSV filename
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yy = String(now.getFullYear()).slice(-2);
        const HH = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}_${mm}_${yy}_${HH}_${min}`;

        resultSheets.push({
            name: `API Request JSON - ${timestamp}.json`,
            content: JSON.stringify(data, null, 2)
        });

        if (errorresData?.length > 0) {

            const headers = [
                "CONTENT ID",
                "ENTITY",
                "ENTITY TYPE",
                "QUESTIONS",
                "OPTIONS",
                "ANSWER",
                "DIFFICULTY",
                "GAME TYPE",
                "ERROR"
            ];

            const rows = errorresData?.map((batch) => [
                batch?.contentId || "",
                batch?.entityName || "",
                batch?.entityCategory || "",
                batch?.questionText || "",
                Array.isArray(batch?.options) ? batch.options.join(';') : (batch?.options || ""),
                batch?.answer || "",
                (batch?.difficulty === 0 ? "Easy" : batch?.difficulty === 1 ? "Medium" : batch?.difficulty === 2 ? "Difficult" : batch?.difficulty || ""),
                Array.isArray(batch?.gameType) ? batch.gameType.join(';') : (batch?.gameType || ""),
                batch?.error || ""
            ]);
            const csvContent = [
                headers?.join(","),
                ...rows?.map((r) => r?.map((v) => `"${String(v)?.replace(/"/g, '""')}"`)?.join(",")),
            ]?.join("\n");

            resultSheets.push({
                name: `QB Server Error Sheet - ${timestamp}.csv`,
                content: csvContent
            });
        }

        if (successResData?.length > 0) {

            const headers = [
                "QUESTION ID",
                "CONTENT ID",
                "ENTITY",
                "ENTITY TYPE",
                "QUESTIONS",
                "OPTIONS",
                "ANSWER",
                "DIFFICULTY",
                "GAME TYPE",
            ];

            const rows = successResData?.map((batch) => [
                batch?.id || batch?._id || "",
                batch?.contentId || "",
                batch?.entityName || "",
                batch?.entityCategory || "",
                batch?.questionText || "",
                Array.isArray(batch?.options) ? batch.options.join(';') : (batch?.options || ""),
                batch?.answer || "",
                (batch?.difficulty === 0 ? "Easy" : batch?.difficulty === 1 ? "Medium" : batch?.difficulty === 2 ? "Difficult" : batch?.difficulty || ""),
                Array.isArray(batch?.gameType) ? batch.gameType.join(';') : (batch?.gameType || ""),
            ]);
            const csvContent = [
                headers?.join(","),
                ...rows?.map((r) => r?.map((v) => `"${String(v)?.replace(/"/g, '""')}"`)?.join(",")),
            ]?.join("\n");

            resultSheets.push({
                name: `QB Server Success Sheet - ${timestamp}.csv`,
                content: csvContent
            });
        }

        // Wait for all resultSheets to be populated before zipping (simple debounce)
        setTimeout(() => {
            if (resultSheets.length > 0) {
                const zip = new JSZip();
                resultSheets.forEach(sheet => {
                    zip.file(sheet.name, sheet.content);
                });
                zip.generateAsync({ type: "blob" }).then(function (zipBlob) {
                    // Send email with zipBlob as attachment
                    const zipFile = new File([zipBlob], `QB Result - ${timestamp}.zip`, { type: 'application/zip' });

                    // sendQuestionBankUploadMail({
                    //     fromEmails: process.env.MAIL_USER,
                    //     toEmails: [process.env.MAIL_USER],
                    //     subject: "Question Bank Upload Result",
                    //     summary: {
                    //         totalQuestions: data.length,
                    //         successCount: successResData.length,
                    //         failedCount: errorresData.length
                    //     },
                    //     attacheFile: zipFile,
                    //     deviceInfo: {
                    //         ip: "N/A",
                    //         deviceType: "N/A",
                    //         os: "N/A",
                    //         browser: "N/A",
                    //         userAgent: navigator.userAgent
                    //     }
                    // });

                    // Download zip file for user
                    const url = URL.createObjectURL(zipBlob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `QB Result - ${timestamp}.zip`;
                    link.click();
                    URL.revokeObjectURL(url);
                });
            }
        }, 300);
    }

    const csvToJsonEntity = async (results) => {
        // Validate CSV headers
        const expectedHeaders = [
            'entityName',
            'entityCategory',
            'displayImageUrl',
            // Add more required headers as needed
        ];
        const actualHeaders = results?.meta?.fields || (results?.data?.length > 0 ? Object.keys(results.data[0]) : []);
        const missingHeaders = expectedHeaders.filter(h => !actualHeaders.includes(h));
        if (missingHeaders.length > 0) {
            setLoader(false);
            console.error('`CSV` header missing & must required fields:', missingHeaders);
            toast.error(`CSV header missing & must required fields: ${missingHeaders.join(', ')}`);
            return;
        }

        // drop the first 2 rows
        const cleaned = results.data.slice(0);

        setCsvData(cleaned);
        setLoader(false);
        console.log('CSV Data (skipped 2 rows):', cleaned);

        // Add timestamp to error CSV filename
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yy = String(now.getFullYear()).slice(-2);
        const HH = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}_${mm}_${yy}_${HH}_${min}`;

        let errors = [];
        const resultSheets = [];
        // map CSV rows into schemas
        const mapped = cleaned.map((row) => mapRowToSchemaEntity(row, errors));

        const validMapped = mapped.filter(Boolean);
        console.log('Mapped Data before filtering nulls:', mapped);
        console.log(`Skipped ${mapped.length - validMapped.length} invalid entity rows`);

        if (!validMapped.length) {
            toast.error('No valid entities found in the CSV. Request was not sent.');
            setMappedData([]);
            return;
        }

        resultSheets.push({
            name: `Entity API Request JSON - ${timestamp}.json`,
            content: JSON.stringify(validMapped, null, 2)
        });
        const result = await pushImportCSVApiEntity(validMapped);
        console.log('Entity Import Result:', result);
        if (result === 500) {
            resultSheets.length = 0;
        }
        setMappedData(validMapped);

        console.log('Result Sheets for Entity:', resultSheets);
        setTimeout(() => {
            if (resultSheets.length > 0) {
                const zip = new JSZip();
                resultSheets.forEach(sheet => {
                    zip.file(sheet.name, sheet.content);
                });
                zip.generateAsync({ type: "blob" }).then(function (zipBlob) {
                    // Send email with zipBlob as attachment
                    const zipFile = new File([zipBlob], `Entity Result - ${timestamp}.zip`, { type: 'application/zip' });

                    // Download zip file for user
                    const url = URL.createObjectURL(zipBlob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `Entity Result - ${timestamp}.zip`;
                    link.click();
                    URL.revokeObjectURL(url);
                });
            }
        }, 300);

        console.log('Mapped Data:', mapped);
    }

    // function to choose schema and map row values - Entity
    const mapRowToSchemaEntity = (row, errors) => {

        // Sanitize all row fields: if value is '#N/A' or 'Not Found', use empty string
        const sanitizedRow = {};
        Object.entries(row).forEach(([k, v]) => {
            if (typeof v === 'string' && (v.trim() === '#N/A' || v.trim() === 'Not Found')) {
                sanitizedRow[k] = '';
            } else {
                sanitizedRow[k] = v.trim() || '';
            }
        });

        if (sanitizedRow.entityName === undefined || sanitizedRow.entityName === "" || sanitizedRow.entityName === null ||
            sanitizedRow.entityCategory === undefined || sanitizedRow.entityCategory === "" || sanitizedRow.entityCategory === null ||
            sanitizedRow.displayImageUrl === undefined || sanitizedRow.displayImageUrl === "" || sanitizedRow.displayImageUrl === null
        ) {
            console.error('Missing required fields in row:', sanitizedRow);
            errors.push(sanitizedRow);
            return null;
        }

        let template = {};

        // Enum for weightage
        const weightageEnum = {
            common: 0,  //'1'
            uncommon: 1,    //'1.5'
            rare: 2,    //'2'
            legendary: 3    //'2.5'
        };

        function addIfExists(obj, key, value) {
            if (value !== undefined && value !== null && value !== "") {
                obj[key] = value;
            }
        }

        function addTriviaCardFields(card, fields) {
            Object.entries(fields).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                    card[key] = value;
                }
            });
        }

        function addMultimediaItem(template, videoUrl, contentId, displayImageUrl, formType = '', triviaCardDisplayImageUrl) {
            // Replace any '#N/A' or 'Not Found' value with empty string (should be redundant now, but for safety)
            videoUrl = (videoUrl === '#N/A' || videoUrl === 'Not Found') ? '' : videoUrl;
            contentId = (contentId === '#N/A' || contentId === 'Not Found') ? '' : contentId;
            displayImageUrl = (displayImageUrl === '#N/A' || displayImageUrl === 'Not Found') ? '' : displayImageUrl;
            formType = (formType === '#N/A' || formType === 'Not Found') ? '' : formType;
            triviaCardDisplayImageUrl = (triviaCardDisplayImageUrl === '#N/A' || triviaCardDisplayImageUrl === 'Not Found') ? '' : triviaCardDisplayImageUrl;

            const multimedia = [];
            if (triviaCardDisplayImageUrl) {
                multimedia.push({
                    contentId: '',
                    form: 'image',
                    newForm: '',
                    type: '',
                    url: triviaCardDisplayImageUrl.trim() || '',
                    aspectRatio: '16:9'
                });
                template.multimedia = multimedia;
            }
            if (videoUrl && contentId && formType) {
                multimedia.push({
                    contentId: contentId,
                    form: 'video',
                    newForm: formType,
                    type: '',
                    url: videoUrl.trim(),
                    aspectRatio: '16:9'
                });
                template.multimedia = multimedia;
                return template;
            }
            else if (displayImageUrl) {
                multimedia.push({
                    contentId: '',
                    form: 'image',
                    newForm: '',
                    type: '',
                    url: displayImageUrl.trim(),
                    aspectRatio: '1:1'
                });
                template.multimedia = multimedia;
                return template;
            }
            else {
                return template;
            }
        }

        // Normalize category: lowercase, replace spaces with underscores
        const normalizedCategory = sanitizedRow.entityCategory ? sanitizedRow.entityCategory.toLowerCase().replace(/\s+/g, '_') : '';
        console.log('normalizedCategory: ', normalizedCategory);
        switch (normalizedCategory) {
            case 'movie':
                template = JSON.parse(JSON.stringify(movie_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                // Map entityWeight string to enum value if possible
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    director: formattedString(sanitizedRow.director),
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    leadCast: formattedString(sanitizedRow.leadCast),
                    writer: formattedString(sanitizedRow.writer),
                    releaseDate: formattedString(sanitizedRow.releaseDate),
                    yearOfRelease: formattedString(sanitizedRow.yearOfRelease),
                    genre: formattedString(sanitizedRow.genre),
                    language: formattedString(sanitizedRow.language),
                    producer: formattedString(sanitizedRow.producer),
                    productionHouse: formattedString(sanitizedRow.productionHouse),
                });
                // Parse history string like "Homebound;₹ 4.74 Cr;production" into { name, collection, association }
                const parseHistory = (str) => {
                    if (!str) return { name: '', collection: '', association: '' };
                    const arr = str.split(';').map(s => s.trim());
                    return {
                        name: arr[0] || '',
                        collection: arr[1] || '',
                        association: arr[2] || ''
                    };
                };
                template.triviaCard.history = template.triviaCard.history || {};
                // Extract value for History-1 by searching for a header containing 'History-1'
                let history1Value = '';
                Object.keys(sanitizedRow).forEach(key => {
                    if (key.toLowerCase().includes('history-1')) {
                        history1Value = sanitizedRow[key];
                    }
                });
                addIfExists(template.triviaCard.history, 'history1', parseHistory(history1Value));
                let history2Value = '';
                Object.keys(sanitizedRow).forEach(key => {
                    if (key.toLowerCase().includes('history-2')) {
                        history2Value = sanitizedRow[key];
                    }
                });
                addIfExists(template.triviaCard.history, 'history2', parseHistory(history2Value));
                let history3Value = '';
                Object.keys(sanitizedRow).forEach(key => {
                    if (key.toLowerCase().includes('history-3')) {
                        history3Value = sanitizedRow[key];
                    }
                });
                addIfExists(template.triviaCard.history, 'history3', parseHistory(history3Value));
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'song':
                template = JSON.parse(JSON.stringify(song_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    musicDirector: formattedString(sanitizedRow.musicDirector),
                    movie: formattedString(sanitizedRow.movie),
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    title: formattedString(sanitizedRow.title),
                    album: formattedString(sanitizedRow.album),
                    singers: formattedString(sanitizedRow.singers),
                    composer: formattedString(sanitizedRow.composer),
                    lyricist: formattedString(sanitizedRow.lyricist),
                    yearOfRelease: formattedString(sanitizedRow.yearOfRelease),
                    last3releasesAverageStreams: formattedString(sanitizedRow.last3releasesAverageStreams || sanitizedRow.mostPopularSongs),
                    currentNumberofStreams: formattedString(sanitizedRow.currentNumberofStreams),
                    positionOnTheplaylist: formattedString(sanitizedRow.positionOnTheplaylist),
                    spotifyStats: formattedString(sanitizedRow.spotifyStats)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'video':
                template = JSON.parse(JSON.stringify(video_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    title: formattedString(sanitizedRow.title),
                    creatorName: formattedString(sanitizedRow.creatorName),
                    channelName: formattedString(sanitizedRow.channelName),
                    releaseDate: formattedString(sanitizedRow.releaseDate),
                    genre: formattedString(sanitizedRow.genre),
                    artists: formattedString(sanitizedRow.artists),
                    trendingListPosition: formattedString(sanitizedRow.trendingListPosition),
                    totalViews: formattedString(sanitizedRow.totalViews),
                    totalChannelSubscribers: formattedString(sanitizedRow.totalChannelSubscribers)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'reel':
                template = JSON.parse(JSON.stringify(reel_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    creatorName: formattedString(sanitizedRow.creatorName),
                    datePosted: formattedString(sanitizedRow.datePosted),
                    genre: formattedString(sanitizedRow.genre),
                    HashTags: formattedString(sanitizedRow.HashTags),
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    totalFollowers: formattedString(sanitizedRow.totalFollowers),
                    likesOfTheLastReel: formattedString(sanitizedRow.likesOfTheLastReel),
                    commentsOnTheLastReel: formattedString(sanitizedRow.commentsOnTheLastReel)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'influencers':
                template = JSON.parse(JSON.stringify(influencers_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    name: formattedString(sanitizedRow.name),
                    platform: formattedString(sanitizedRow.platform),
                    genre: formattedString(sanitizedRow.genre),
                    activeSince: formattedString(sanitizedRow.activeSince),
                    totalFollowers: formattedString(sanitizedRow.totalFollowers),
                    dateOfLastPost: formattedString(sanitizedRow.dateOfLastPost),
                    totalLikesOnLastPost: formattedString(sanitizedRow.totalLikesOnLastPost),
                    commentsOnLastPost: formattedString(sanitizedRow.commentsOnLastPost)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'actor':
                template = JSON.parse(JSON.stringify(actor_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    console.log('weightKey:', weightKey);
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    dateOfBirth: formattedString(sanitizedRow.dateOfBirth),
                    debutMovie: formattedString(sanitizedRow.debutMovie),
                    debutYear: formattedString(sanitizedRow.debutYear),
                    milestoneMovies: formattedString(sanitizedRow.milestoneMovies)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'actress':
                template = JSON.parse(JSON.stringify(actoress_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    dateOfBirth: formattedString(sanitizedRow.dateOfBirth),
                    debutMovie: formattedString(sanitizedRow.debutMovie),
                    debutYear: formattedString(sanitizedRow.debutYear),
                    milestoneMovies: formattedString(sanitizedRow.milestoneMovies)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'music_director':
                template = JSON.parse(JSON.stringify(music_director_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    debutMovie: formattedString(sanitizedRow.debutMovie),
                    milestoneMovies: formattedString(sanitizedRow.milestoneMovies),
                    dateOfBirth: formattedString(sanitizedRow.dateOfBirth),
                    debutYear: formattedString(sanitizedRow.debutYear)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;
            case 'cricketer':
                template = JSON.parse(JSON.stringify(cricketer_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    dateOfBirth: formattedString(sanitizedRow.dateOfBirth),
                    matches: formattedString(sanitizedRow.matches),
                    runs: formattedString(sanitizedRow.runs),
                    wickets: formattedString(sanitizedRow.wickets)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;

            case 'power_batter':
            case 'finisher':
                template = JSON.parse(JSON.stringify(cricketer_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    team: formattedString(sanitizedRow.team),
                    nationality: formattedString(sanitizedRow.nationality),
                    runs: formattedString(sanitizedRow.runs),
                    strikeRate: formattedString(sanitizedRow.strikeRate)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;

            case 'strike_bowler':
            case 'spin_master':
                console.log('case: ', 'spin_master | strike_bowler');
                template = JSON.parse(JSON.stringify(cricketer_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    team: formattedString(sanitizedRow.team),
                    nationality: formattedString(sanitizedRow.nationality),
                    wickets: formattedString(sanitizedRow.wickets),
                    economy: formattedString(sanitizedRow.economy)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;

                case 'x_factor':
                template = JSON.parse(JSON.stringify(cricketer_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                addTriviaCardFields(template.triviaCard, {
                    ytUrl: formattedString(sanitizedRow.youtubeUrl),
                    team: formattedString(sanitizedRow.team),
                    nationality: formattedString(sanitizedRow.nationality),
                    wickets: formattedString(sanitizedRow.wickets),
                    runs: formattedString(sanitizedRow.runs)
                });
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
                break;

            default:
                template = JSON.parse(JSON.stringify(default_ee_json_csv));
                template.entityName = sanitizedRow.entityName;
                template.entityCategory = normalizedCategory;
                template.displayImageUrl = sanitizedRow.displayImageUrl;
                if (typeof sanitizedRow.Weightage === 'string') {
                    const weightKey = sanitizedRow.Weightage.trim().toLowerCase();
                    if (weightageEnum.hasOwnProperty(weightKey)) {
                        template.weightage = weightageEnum[weightKey];
                    } else {
                        addIfExists(template, 'weightage', sanitizedRow.Weightage);
                    }
                } else {
                    addIfExists(template, 'weightage', sanitizedRow.Weightage);
                }
                if (template?.weightage !== undefined && template.weightage !== null && template.weightage !== "") {
                    // do nothing
                }
                else {
                    addIfExists(template, 'displayImageUrl', sanitizedRow.displayImageUrl);
                }
                addMultimediaItem(template, sanitizedRow.videoUrl, sanitizedRow.contentId, sanitizedRow.displayImageUrl, sanitizedRow.Form, sanitizedRow.triviaCardDisplayImageUrl);
        }

        // Accept content_tag / content_tags / TAGS (and location/language variants)
        template.content_tag = parseTagField(getCsvField(sanitizedRow, CONTENT_TAG_ALIASES));
        template.location_tag = parseTagField(getCsvField(sanitizedRow, LOCATION_TAG_ALIASES));
        template.language_tag = parseTagField(getCsvField(sanitizedRow, LANGUAGE_TAG_ALIASES));
        if (Array.isArray(template.multimedia) && template.multimedia.length > 0) {
            template.multimedia = template.multimedia.map((m) => ({
                ...m,
                content_tag: template.content_tag,
                location_tag: template.location_tag,
                language_tag: template.language_tag,
            }));
        }

        // Helper to recursively remove empty keys from an object
        function removeEmptyKeys(obj) {
            if (Array.isArray(obj)) {
                return obj
                    .map(removeEmptyKeys)
                    .filter((v) => v !== undefined && v !== null && v !== '' && (typeof v !== 'object' || Object.keys(v).length > 0));
            } else if (typeof obj === 'object' && obj !== null) {
                const newObj = {};
                Object.entries(obj).forEach(([k, v]) => {
                    // Always keep 'multimedia' and 'displayImageUrl' keys, even if empty/null
                    if (k === 'multimedia') {
                        newObj[k] = v;
                        return;
                    }
                    // Keep tag arrays even when empty so backend can clear/set them consistently
                    if (k === 'content_tag' || k === 'location_tag' || k === 'language_tag') {
                        newObj[k] = Array.isArray(v) ? v : [];
                        return;
                    }
                    const cleaned = removeEmptyKeys(v);
                    if (
                        cleaned !== undefined &&
                        cleaned !== null &&
                        cleaned !== '' &&
                        !(typeof cleaned === 'object' && Object.keys(cleaned).length === 0)
                    ) {
                        newObj[k] = cleaned;
                    }
                });
                return newObj;
            }
            return obj;
        }

        return removeEmptyKeys(template);
    };

    const csvToJsonStats = (results) => {
        // drop the first 2 rows
        const cleaned = results.data.slice(0);

        setCsvData(cleaned);
        setLoader(false);
        console.log('CSV Data (skipped 2 rows):', cleaned);

        // map CSV rows into schemas
        //const mapped = cleaned.map((row) => mapRowToSchemaEntity(row));
        const mapped = cleaned.map((row) => mapRowToSchemaStats(row));
        const requestBody = { entities: mapped }

        // Validate: for each entity, any key other than _id or name must NOT be empty/null/undefined (0 is allowed)
        try {
            const hasEmpty = Array.isArray(requestBody?.entities) && requestBody.entities.some((ent) => {
                if (!ent || typeof ent !== 'object') return true; // invalid shape
                return Object.entries(ent).some(([k, v]) => {
                    //console.log(`Validating key: ${k}, value: ${v}`);
                    if (k === '_id' || k === 'name') return false;
                    if (v === null || v === undefined) return true;
                    if (typeof v === 'number') return false; // allow 0
                    const s = String(v).trim();
                    return s === '';
                });
            });
            if (hasEmpty) {
                toast.error('Invalid stats: fields other than ID/Name contain empty values. Fix and retry.');
                setLoader(false);
                return;
            }
        } catch (e) {
            // if validation throws, block upload for safety
            toast.error('Invalid CSV structure for stats upload.');
            setLoader(false);
            return;
        }

        pushImportCSVApiFantasyStats(requestBody);
        setMappedData(mapped);
        console.log('Mapped Data:', mapped);
    }

    // function to choose schema and map row values - Stats
    const mapRowToSchemaStats = (row) => {
        let template = {};

        switch ((row.entityCategory || '').toLowerCase()) {
            case 'movies':
            case 'movie':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_movie));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.collection = parseFloat(row.boxOfficeCollection) || -1;
                break;

            case 'songs':
            case 'song':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_song));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.count = parseFloat(row.streamCount) || -1;
                template.pos = parseInt(row.rank, 10) || -1;
                break;

            case 'videos':
            case 'video':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_video));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.view = parseFloat(row.viewCount) || -1;
                break;

            case 'reels':
            case 'reel':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_reel));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.view = parseFloat(row.viewCount) || -1;
                template.comment = parseFloat(row.commentCount) || -1;
                template.share = parseFloat(row.shareCount) || -1;
                break;

            case 'influencers':
            case 'influencer':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_influencers));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.view = parseFloat(row["view/likesCount"]) || -1;
                template.follower = parseFloat(row.followerCount) || -1;
                template.upload = parseFloat(row.uploadCount) || -1;
                break;

            case 'power_batter':
            case 'finisher':
            case 'power_batters':
            case 'finishers':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_batsman));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.runs = parseFloat(row.runs) || -1;
                template.strikeRate = parseFloat(row.strikeRate) || -1;
                break;

            case 'strike_bowler':
            case 'spin_master':
            case 'strike_bowlers':
            case 'spin_masters':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_bowler));
                template.entityId = row.entityID || row.entityId || row.id || '';
                template.name = row.entityName || row.name || '';
                template.category = row.entityCategory || row.category || '';

                template.wickets = parseFloat(row.wickets) || -1;
                const economyValue = row.economy ?? row.Economy ?? row.economyRate ?? row.ECONOMY ?? row.econmy;
                template.economyRate = parseFloat(economyValue) || -1;

                // Clean leftover edge-typo keys (legacy or malformed headers)
                if (template.econmy !== undefined) delete template.econmy;
                if (template.econmyRate !== undefined) {
                    template.economyRate = parseFloat(template.econmyRate) || template.economyRate;
                    delete template.econmyRate;
                }
                break;

            case 'x_factor':
            case 'x_factors':
                template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_stats_csv_allRounder));
                template.entityId = row.entityID;
                template.name = row.entityName;
                template.category = row.entityCategory;
                template.wickets = parseFloat(row.wickets) || -1;
                template.runs = parseFloat(row.runs) || -1;
                break;

            default:
                template = row; // fallback: keep raw
        }

        return template;
    };

    const parseHousieCsvResults = (results) => {
        try {
            const cleaned = results?.data?.slice(0); // keep full matrix
            if (!cleaned || cleaned.length === 0) {
                return [];
            }

            // normalize matrix and trim cells
            const matrix = cleaned.map((row) =>
                (row || []).map((cell) => (cell === null || cell === undefined ? '' : String(cell).trim()))
            );

            const rows = matrix.length;
            const cols = matrix[0]?.length || 0;
            const normalize = (s = '') => String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
            const parseTags = (raw) => splitSemicolonArray(String(raw ?? '').split(',').join(';'));

            const isTimelineHeaderRow = (row = []) => {
                let matchCount = 0;
                for (let c = 0; c < row.length; c++) {
                    const cellNorm = normalize(row[c]);
                    if (!cellNorm) continue;
                    if (
                        cellNorm.includes('timestamp') ||
                        cellNorm === 'time' ||
                        cellNorm.includes('entityname') ||
                        cellNorm.includes('entitycategory') ||
                        cellNorm.includes('displayimage')
                    ) {
                        matchCount++;
                    }
                }
                return matchCount >= 2;
            };

            const isSampleStart = (row = []) => {
                const key = normalize(row[0] || '');
                return key === 'videourl' || key.includes('videourl') || key === 'sample' || key.startsWith('sampe') || key.startsWith('sample');
            };

            // Split stacked vertical samples (rh_video_sample sheet format)
            const sampleStarts = [];
            for (let r = 0; r < rows; r++) {
                if (isSampleStart(matrix[r]) && normalize(matrix[r][0] || '').includes('video')) {
                    sampleStarts.push(r);
                }
            }

            const parsedTemplates = [];

            const parseBlock = (startRow, endRow) => {
                const template = JSON.parse(JSON.stringify(rap_housie_game_csv));
                let timelineHeaderRow = -1;

                for (let r = startRow; r < endRow; r++) {
                    if (isTimelineHeaderRow(matrix[r])) {
                        timelineHeaderRow = r;
                        break;
                    }
                    const keyNorm = normalize(matrix[r][0] || '');
                    const value = matrix[r][1] || '';
                    if (!keyNorm) continue;

                    if (keyNorm.includes('videourl') || keyNorm === 'videourl') template.videoUrl = value;
                    else if (keyNorm.includes('duration')) template.duration = value;
                    else if (keyNorm.includes('theme')) template.theme = value;
                    else if (keyNorm === 'contenttag' || keyNorm.includes('contenttag')) template.content_tag = parseTags(value);
                    else if (keyNorm === 'locationtag' || keyNorm.includes('locationtag')) template.location_tag = parseTags(value);
                    else if (keyNorm === 'languagetag' || keyNorm.includes('languagetag')) template.language_tag = parseTags(value);
                    else if (keyNorm === 'tag' || keyNorm === 'tags') {
                        // legacy single "tag" column -> content_tag
                        if (!template.content_tag?.length) template.content_tag = parseTags(value);
                    }
                }

                const timeLine = [];
                if (timelineHeaderRow > -1) {
                    const headerMap = {};
                    for (let c = 0; c < cols; c++) {
                        const hn = normalize(matrix[timelineHeaderRow][c] || '');
                        if (!hn) continue;
                        if (hn.includes('timestamp') || hn === 'time') headerMap.time = c;
                        else if (hn.includes('entityname') || hn === 'name' || hn === 'entity') headerMap.entityName = c;
                        else if (hn.includes('entitycategory') || hn === 'category') headerMap.entityCategory = c;
                        else if (hn.includes('displayimage') || hn.includes('image')) headerMap.displayImageUrl = c;
                    }

                    for (let r = timelineHeaderRow + 1; r < endRow; r++) {
                        // stop if next sample starts inside block
                        if (isSampleStart(matrix[r]) && normalize(matrix[r][0] || '').includes('video')) break;

                        const ts = headerMap.time != null ? matrix[r][headerMap.time] || '' : '';
                        const en = headerMap.entityName != null ? matrix[r][headerMap.entityName] || '' : '';
                        const ec = headerMap.entityCategory != null ? matrix[r][headerMap.entityCategory] || '' : '';
                        const img = headerMap.displayImageUrl != null ? matrix[r][headerMap.displayImageUrl] || '' : '';

                        if ([ts, en, ec, img].every((v) => (v || '').trim() === '')) continue;
                        // skip accidental key rows
                        if (normalize(ts).includes('video') || normalize(en) === 'entityname') continue;

                        timeLine.push({
                            time: ts,
                            entityName: en,
                            entityCategory: ec,
                            displayImageUrl: img,
                        });
                    }
                }

                // Bare Cloudflare Stream IDs (32-hex) are sent as videoUrl; normalize for backend
                if (template.videoUrl && !String(template.videoUrl).startsWith('http')) {
                    template.cloudFlareVideoId = String(template.videoUrl).trim();
                }

                template.timeLine = timeLine;
                return template;
            };

            if (sampleStarts.length > 0) {
                for (let i = 0; i < sampleStarts.length; i++) {
                    const start = sampleStarts[i];
                    const end = i + 1 < sampleStarts.length ? sampleStarts[i + 1] : rows;
                    const template = parseBlock(start, end);
                    if (template.videoUrl || template.cloudFlareVideoId || (template.timeLine && template.timeLine.length > 0)) {
                        parsedTemplates.push(template);
                    }
                }
            }

            // Fallback: multi-column format (one sample per column)
            if (parsedTemplates.length === 0) {
                let timelineHeaderRow = -1;
                for (let r = 0; r < rows; r++) {
                    if (isTimelineHeaderRow(matrix[r])) {
                        timelineHeaderRow = r;
                        break;
                    }
                }
                const mainKeyRowsEnd = timelineHeaderRow === -1 ? Math.min(rows, 10) : timelineHeaderRow;

                for (let col = 1; col < cols; col++) {
                    let hasMainData = false;
                    for (let r = 0; r < mainKeyRowsEnd; r++) {
                        if ((matrix[r][col] || '').trim() !== '') {
                            hasMainData = true;
                            break;
                        }
                    }
                    if (!hasMainData) continue;

                    const template = JSON.parse(JSON.stringify(rap_housie_game_csv));
                    for (let r = 0; r < mainKeyRowsEnd; r++) {
                        const keyNorm = normalize(matrix[r][0] || '');
                        const value = matrix[r][col] || '';
                        if (!value) continue;

                        if (keyNorm.includes('video')) template.videoUrl = value;
                        else if (keyNorm.includes('duration')) template.duration = value;
                        else if (keyNorm.includes('theme')) template.theme = value;
                        else if (keyNorm.includes('contenttag')) template.content_tag = parseTags(value);
                        else if (keyNorm.includes('locationtag')) template.location_tag = parseTags(value);
                        else if (keyNorm.includes('languagetag')) template.language_tag = parseTags(value);
                        else if (keyNorm === 'tag' || keyNorm === 'tags') {
                            if (!template.content_tag?.length) template.content_tag = parseTags(value);
                        }
                    }

                    const timeLine = [];
                    if (timelineHeaderRow > -1) {
                        const headerMap = {};
                        for (let c = 0; c < cols; c++) {
                            const hn = normalize(matrix[timelineHeaderRow][c] || '');
                            if (!hn) continue;
                            if (hn.includes('timestamp') || hn === 'time') headerMap.time = c;
                            else if (hn.includes('entityname') || hn === 'name' || hn === 'entity') headerMap.entityName = c;
                            else if (hn.includes('entitycategory') || hn === 'category') headerMap.entityCategory = c;
                            else if (hn.includes('displayimage') || hn.includes('image')) headerMap.displayImageUrl = c;
                        }

                        for (let r = timelineHeaderRow + 1; r < rows; r++) {
                            const ts = headerMap.time != null ? matrix[r][headerMap.time] || '' : '';
                            const en = headerMap.entityName != null ? matrix[r][headerMap.entityName] || '' : '';
                            const ec = headerMap.entityCategory != null ? matrix[r][headerMap.entityCategory] || '' : '';
                            const img = headerMap.displayImageUrl != null ? matrix[r][headerMap.displayImageUrl] || '' : '';
                            if ([ts, en, ec, img].every((v) => (v || '').trim() === '')) continue;
                            timeLine.push({ time: ts, entityName: en, entityCategory: ec, displayImageUrl: img });
                        }
                    }

                    if (template.videoUrl && !String(template.videoUrl).startsWith('http')) {
                        template.cloudFlareVideoId = String(template.videoUrl).trim();
                    }

                    template.timeLine = timeLine;
                    parsedTemplates.push(template);
                }
            }

            console.log('📊 Parsed housie templates:', parsedTemplates);
            return parsedTemplates;
        } catch (err) {
            console.error('parseHousieCsvResults error:', err);
            return [];
        }
    };

    const csvToJsonHousie = (results) => {
        const parsedTemplates = parseHousieCsvResults(results);
        if (!parsedTemplates.length) {
            setLoader(false);
            toast.error('No Rap Housie games found in this CSV.');
            return;
        }
        setMappedData(parsedTemplates);
        pushImportCSVApiHousie(parsedTemplates);
    };

    const parseCsvFile = (file) => new Promise((resolve, reject) => {
        Papa.parse(file, {
            encoding: "UTF-8",
            header: false,
            skipEmptyLines: true,
            complete: resolve,
            error: reject,
        });
    });

    const housieApiMessage = (response) => (
        response?.response?.data?.error?.message
        || response?.data?.error?.message
        || response?.error?.message
        || response?.message
        || "Request failed"
    );

    const isHousieHttpOk = (response) => response?.status === 200 || response?.status === 201;

    const drainHousieBatch = async (rowCount) => {
        const maxCalls = Math.max(Number(rowCount) || 0, 1) + 5;
        for (let i = 0; i < maxCalls; i++) {
            const response = await api_service.processTambolaVideo();
            if (!isHousieHttpOk(response)) {
                return { ok: false, message: housieApiMessage(response) };
            }
            const rows = response?.data;
            if (!Array.isArray(rows) || rows.length === 0) {
                return { ok: true, message: "" };
            }
        }
        return { ok: false, message: "Processing did not finish for this CSV" };
    };

    const summarizeLatestHousieBatch = async () => {
        const listResponse = await api_service.getCsvBatchList();
        if (!isHousieHttpOk(listResponse)) {
            return { status: "Failed", message: housieApiMessage(listResponse) };
        }
        const latest = (listResponse?.data || []).find((batch) => batch?.type === "tambolavideo");
        if (!latest?._id) {
            return { status: "Failed", message: "Housie batch was not found after upload" };
        }
        const detailResponse = await api_service.getCsvBatchDetail({ batchId: latest._id });
        if (!isHousieHttpOk(detailResponse)) {
            return { status: "Failed", message: housieApiMessage(detailResponse) };
        }
        const rows = detailResponse?.data?.data || [];
        const failed = rows.filter((row) => String(row?.status || "").toLowerCase() === "fail");
        const completed = rows.filter((row) => String(row?.status || "").toLowerCase() === "complete");
        const failText = failed.map((row) => row?.statusMsg).filter(Boolean).join(" | ");
        if (failed.length && !completed.length) {
            return { status: "Failed", message: failText || "Processing failed" };
        }
        if (failed.length) {
            return {
                status: "Partial",
                message: `${completed.length} complete, ${failed.length} failed. ${failText}`.trim(),
            };
        }
        return {
            status: "Success",
            message: `${completed.length} game${completed.length === 1 ? "" : "s"} processed`,
        };
    };

    const handleHousieFolderChange = async (e) => {
        const inputElement = e.target;
        const files = Array.from(inputElement.files || []).filter((file) => (
            file.name.toLowerCase().endsWith(".csv") && !file.name.startsWith(".")
        ));

        if (!files.length) {
            toast.error("No CSV files found in the selected folder.");
            inputElement.value = null;
            return;
        }

        const folderName = files[0].webkitRelativePath
            ? files[0].webkitRelativePath.split("/")[0]
            : "";
        const trailingNumber = (name) => {
            const base = name.replace(/\.[^/.]+$/, "");
            const match = base.match(/(\d+)$/);
            return match ? parseInt(match[1], 10) : Number.MAX_SAFE_INTEGER;
        };
        const sortedFiles = [...files].sort((a, b) => {
            const numberDiff = trailingNumber(a.name) - trailingNumber(b.name);
            if (numberDiff !== 0) return numberDiff;
            return a.webkitRelativePath.localeCompare(b.webkitRelativePath);
        });

        setSelectedFolderName(folderName);
        setFolderUploading(true);
        setTotalFiles(sortedFiles.length);
        setUploadedFiles(0);
        setCurrentFileName("");

        let wakeLock = null;
        try {
            if (navigator?.wakeLock?.request) {
                wakeLock = await navigator.wakeLock.request("screen");
            }
        } catch (_) { }

        const report = [];
        for (const file of sortedFiles) {
            setCurrentFileName(file.name);
            let status = "Failed";
            let message = "";
            try {
                const results = await parseCsvFile(file);
                const templates = parseHousieCsvResults(results);
                if (!templates.length) {
                    message = "No Rap Housie games found in this CSV";
                } else {
                    let uploadResponse = await api_service.pushImportCSVHousie({ data: templates });
                    if (!isHousieHttpOk(uploadResponse) && housieApiMessage(uploadResponse).toLowerCase().includes("another batch")) {
                        await drainHousieBatch(200);
                        uploadResponse = await api_service.pushImportCSVHousie({ data: templates });
                    }
                    if (!isHousieHttpOk(uploadResponse) || uploadResponse?.data?.status !== "done") {
                        message = isHousieHttpOk(uploadResponse)
                            ? "Server did not accept this CSV"
                            : housieApiMessage(uploadResponse);
                    } else {
                        const drained = await drainHousieBatch(templates.length);
                        if (!drained.ok) {
                            message = drained.message;
                        } else {
                            const summary = await summarizeLatestHousieBatch();
                            status = summary.status;
                            message = summary.message;
                        }
                    }
                }
            } catch (err) {
                message = err?.message || "Failed to read CSV";
            }
            report.push({ file: file.webkitRelativePath || file.name, status, message });
            setUploadedFiles((prev) => prev + 1);
            setCurrentFileName("");
        }

        setFolderUploading(false);
        try { await wakeLock?.release(); } catch (_) { }

        const escapeCsv = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
        const csvContent = [
            "File,Status,Message",
            ...report.map((row) => [escapeCsv(row.file), escapeCsv(row.status), escapeCsv(row.message)].join(",")),
        ].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const timestamp = new Date().toLocaleString("en-GB").replace(/[/:, ]/g, "_");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `RapHousie_CSV_Report_${timestamp}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        const successCount = report.filter((row) => row.status === "Success").length;
        const failCount = report.length - successCount;
        if (successCount > 0 && failCount === 0) {
            toast.success(`${successCount} CSV${successCount > 1 ? "s" : ""} processed`);
        } else if (successCount > 0) {
            toast.info(`${successCount} processed, ${failCount} failed. Check the CSV report.`);
        } else {
            toast.error(`Folder upload finished with ${failCount} failure${failCount > 1 ? "s" : ""}. Check the CSV report.`);
        }

        inputElement.value = null;
        getCsvBatchListApi();
    };

    const csvToJsonFantasyLeague = (results) => {
        try {
            //console.log('csvToJsonFantasyLeague called : ',results);
            setLoader(true);
            const cleaned = results.data.slice(0); // full matrix
            if (!cleaned || cleaned.length === 0) return;

            //console.log('Cleaned Data:', cleaned);
            // Trim and normalize
            const matrix = cleaned.map((row) =>
                (row || []).map((cell) => (cell === null || cell === undefined ? "" : String(cell).trim()))
            );

            //console.log("matrix:", matrix);

            const rows = matrix.length;
            const cols = matrix[0].length;

            //console.log("Rows:", rows);
            const normalize = (s = "") => String(s).toLowerCase().replace(/[^a-z0-9]/g, "");

            var errors = [];

            // Find media header (where columns contain entityName, entityCategory, etc.)
            let mediaHeaderRow = -1;
            for (let r = 0; r < rows; r++) {
                const row = matrix[r].map(normalize);
                console.log("Checking row for media headers:", row);
                // Compare against normalized header names
                const hasMediaHeaders = matrix[r].includes("entityName") && matrix[r].includes("entityCategory") && matrix[r].includes("displayImageUrl");
                if (hasMediaHeaders) {
                    mediaHeaderRow = r;
                    break;
                }
            }

            console.log("📊 Media Header Row:", mediaHeaderRow);

            if (mediaHeaderRow === -1) {
                errors.push("Invalid Fantasy League CSV: Missing media header row with required columns (entityName, entityCategory, displayImageUrl).");
            }

            const mainDataEnd = mediaHeaderRow === -1 ? rows : mediaHeaderRow;
            const template = JSON.parse(JSON.stringify(rap_real_fantasy_league_game_csv));

            console.log("📊 mainDataEnd:", mainDataEnd);

            var goLiveAtMs = null;
            var matchTimeMs = null;
            // Map vertical key/value pairs
            for (let r = 0; r < mainDataEnd; r++) {
                const key = normalize(matrix[r][0])?.trim();
                const value = matrix[r][1] || "";

                if (!key || !value) continue;

                console.log(`Mapping key: "${key}" with value: "${value}"`);

                if (key.includes("banner") || key.includes("gamebannerla")) template.banner = value;
                //else if (key.includes("gamebannerla")) template.banner = value;
                else if (key.includes("sponsername")) template.sponser.name = value;
                else if (key?.includes("sponserbannerurl")) template.sponser.banner = value;
                else if (key.includes("gametheme")) template.gameTheme = value;
                else if (key.includes("team01")) template.team01 = value;
                else if (key.includes("team02")) template.team02 = value;
                else if (key.includes("matchtime")){
                     matchTimeMs = timestampToMilliseconds(value);
                }
                else if (key.includes("goliveat") || key.includes("goLiveAt")) {
                    goLiveAtMs = timestampToMilliseconds(value);
                    template.goLiveAt = goLiveAtMs;
                    // Add 12 hours (12 * 60 * 60 * 1000 ms) to goLiveAt for submissionCutOffAt
                    template.submissionCutOffAt = goLiveAtMs + 12 * 60 * 60 * 1000;
                    template.resultDeclarationAt = goLiveAtMs + 84 * 60 * 60 * 1000;
                }
            }

            if(template.gameTheme === "RPL"){
                 // Set resultDeclarationAt next day 11:59 AM if matchTime is provided
                let date = new Date(matchTimeMs);
                date.setDate(date.getDate() + 1);
                date.setHours(11, 59, 0, 0);
                template.submissionCutOffAt = matchTimeMs;
                template.resultDeclarationAt = date.getTime();
            }

            const now = Date.now();
            if (template.goLiveAt === undefined ||
                template.goLiveAt === null ||
                template.goLiveAt === "" ||
                isNaN(template.goLiveAt) ||
                template.goLiveAt <= 0
            ) {
                errors.push("Invalid Fantasy League CSV: 'goLiveAt' has invalid timestamp format.");
            }
            if (goLiveAtMs < now) {
                errors.push("Invalid Fantasy League CSV: 'goLiveAt' cannot be in the past.");
            }
            if (template.banner === undefined || template.banner === null || template.banner === "") {
                errors.push("Invalid Fantasy League CSV: 'banner' cannot be empty.");
            }
            if (template.gameTheme === "RPL" && (template.matchTime === "" || template.team01 === "" || template.team02 === "")) {
                errors.push("Invalid Fantasy League CSV: 'RPL - missing matchTime | team01 | team02' cannot be empty.");
            }

            // Parse media entries
            const media = [];
            if (mediaHeaderRow > -1) {
                const headers = matrix[mediaHeaderRow];
                const colIndex = {
                    entityName: headers.indexOf("entityName"),
                    entityCategory: headers.indexOf("entityCategory"),
                    displayImageUrl: headers.indexOf("displayImageUrl"),
                };

                for (let r = mediaHeaderRow + 1; r < rows; r++) {
                    const entityName = colIndex.entityName >= 0 ? matrix[r][colIndex.entityName] || "" : "";
                    const entityCategory = colIndex.entityCategory >= 0 ? matrix[r][colIndex.entityCategory] || "" : "";
                    const displayImageUrl = colIndex.displayImageUrl >= 0 ? matrix[r][colIndex.displayImageUrl] || "" : "";

                    // Check for blank/empty fields
                    if (!entityName.trim() || !entityCategory.trim() || !displayImageUrl.trim()) {
                        errors.push(`Invalid Fantasy League CSV: Media row ${r + 1} has blank entityName, entityCategory, or displayImageUrl.`);
                        continue;
                    }

                    media.push({
                        entityName,
                        entityCategory,
                        displayImageUrl,
                    });
                }
            }

            template.media = media;

            console.log("🎮 Parsed Fantasy League Template:", template);
            if (errors?.length > 0) {
                toast.error(errors.join('\n'));
            }
            else if (template !== null) {
                pushImportCSVApiFantasy([template])
                setMappedData([template]);  // <- you can use this if you manage state
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.error("csvToJsonFantasyLeague error:", err);
        }
    };

    // ✅ 2️⃣ Generate CSV Content from data
    const generateCSVContent = (data) => {
        //console.log("data : ",data)
        const headers = [
            "ID",
            "Entity Name",
            "Entity Category",
            // "Entity SubCategory",
            "Status",
            "Status Msg",
            //"Created At",
            //"Updated At",
        ];

        const rows = data?.map((batch) => [
            batch?._id || "",
            batch?.data?.entityName || "",
            batch?.data?.entityCategory || "",
            // batch?.data?.entitySubCategory || "",
            batch?.status || "",
            batch?.statusMsg || "",
            //formatDateTime(batch?.created_at||''),
            //formatDateTime(batch?.updated_at||''),
        ]);

        const csvContent = [
            headers?.join(","),
            ...rows?.map((r) => r?.map((v) => `"${String(v)?.replace(/"/g, '""')}"`)?.join(",")),
        ]?.join("\n");

        return csvContent;
    };

    // ✅ 3️⃣ Download CSV File
    const downloadCSV = (data, filename) => {
        console.log('🔄 Downloading CSV for data:', data);
        if (!data?.length) {
            alert("No data available to download!");
            return;
        }

        const csvContent = generateCSVContent(data);
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${filename}.csv`;
        link.click();

        URL.revokeObjectURL(url);
    };

    return (
        <>
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    width: '100%',
                    paddingTop: '80px',
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingBottom: '20px',

                }}>

                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                    padding: 4,
                    position: "sticky",   // ✅ stick within parent container
                    top: 0,               // ✅ stick to the top
                    zIndex: 5,            // ✅ ensure it stays above content
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd", // optional for visual separation
                }}>

                    <Box style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: "flex",
                        flex: 0,
                        flexDirection: "row",
                        gap: 2,
                    }}>
                        <Typography variant="h5" sx={{ width: 120, mt: 0, fontWeight: 700, textAlign: 'end' }}>Upload CSV</Typography>
                        <IconButton
                            color="black"
                            size='large'
                            style={{ ml: 4 }}
                            onClick={() => {
                                console.log('Refresh clicked');
                                getCsvBatchListApi();
                            }}
                        >
                            <RefreshIcon />
                        </IconButton>
                    </Box>

                    {/* {fileName && <Typography sx={{ mt: 0, ml: 10, textAlign: 'left' }}>Selected File: {fileName}</Typography>} */}

                    <Box style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: "flex",
                        flex: 0,
                        flexDirection: "row",
                        gap: 2,
                    }}>
                        <FormControl style={{ width: "240px" }}>
                            <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>{"Select CSV Type"}</InputLabel>
                            <Select
                                value={selectedCSVType || ''}
                                onChange={(e) => setSelectedCSVType(e.target.value)}
                                label={"Select CSV Type"}
                                sx={GameCssStyles.formFiledStyle_sx2}
                            >
                                <MenuItem value="" disabled>{`Select CSV`}</MenuItem>
                                {[
                                    "Entity",
                                    "Rap Fantasy League Game",
                                    "Rap Housie Game",
                                    "Submit Stats",
                                    "Unknown Content ID Mapping",
                                    //"Shemaroo Entity Sheet - SHM",
                                    //"Shemaroo Entity Sheet - SHA",
                                    //"Shemaroo Entity Sheet - SHV",
                                    //"Entity Vimeo Playable URL",
                                    "Open Source Question Bank"]?.map((item, idx) => (
                                        <MenuItem key={idx} value={item || ''} sx={GameCssStyles.menuItemStyle_sx}>
                                            {item}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>

                        {selectedCSVType && <Button
                            variant="contained"
                            color="success"
                            component="label"   // 👈 makes the button act like a label for the input
                            sx={{ borderRadius: 2, textTransform: "none", ml: 5, mr: 0, height: 40, width: '150px' }}
                            onClick={() => {

                            }}>
                            Upload CSV File
                            {/* Hidden file input */}
                            <Input
                                type="file"
                                accept=".csv"
                                onChange={handleFileChange}
                                sx={{ display: 'none' }}
                            />
                        </Button>}

                        {selectedCSVType === "Rap Housie Game" && <Button
                            variant="contained"
                            color="success"
                            component="label"
                            disabled={folderUploading}
                            sx={{ borderRadius: 2, textTransform: "none", ml: 2, mr: 0, height: 40, width: '160px' }}
                        >
                            Upload Folder
                            <input
                                type="file"
                                webkitdirectory="true"
                                directory=""
                                multiple
                                accept=".csv"
                                hidden
                                onChange={handleHousieFolderChange}
                            />
                        </Button>}

                        {(selectedCSVType && mappedData !== null && mappedData?.length > 0) && <Button
                            variant="contained"
                            color="success"
                            sx={{ borderRadius: 2, textTransform: "none", ml: 5, mr: 0, height: 40, width: '150px' }}
                            onClick={() => {
                                setOpenViewJSONDialog(true);
                            }}>
                            Preview CSV-JSON
                        </Button>}
                    </Box>

                </Box>

                <Box
                    sx={{
                        flex: 1,
                        height: '100%',
                        width: '100%',
                        mt: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0, // important for flex children to grow/shrink
                    }}>

                    {/* {latestBatch && 
                    <Box
                        sx={{
                            flex: 0,
                            width: '100%',
                            overflow: 'auto',
                            mt: 0,
                            border: latestBatch?.status === 'pending' ? '2px solid #ff0000ff' : '2px solid #078f07ff',
                            background: latestBatch?.status === 'pending' ? '#ff000010' : '#078f0710',
                            borderRadius: 1,
                            p: 2,
                            flexDirection: 'column',
                            gap: 1.5,
                        }}>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}>
                            <Typography variant="h6" fontWeight={600} mb={0}>Batch ID : {latestBatch?._id}</Typography>
                            <Typography variant="h6" fontWeight={600} mb={0}>Batch Name : {latestBatch?.batchName}</Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}>
                            <Typography variant="h6" fontWeight={600} mb={0}>Batch Type : {latestBatch?.type}</Typography>
                            <Typography variant="h6" fontWeight={600} mb={0}>Batch process Starts : {formatDateTime(latestBatch?.created_at)}</Typography>

                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}>
                            <Typography variant="h6" fontWeight={600} mb={0}>Batch Status : {latestBatch?.status}</Typography>
                            <Typography variant="h6" fontWeight={600} mb={0}>Batch process Last update : {formatDateTime(latestBatch?.updated_at)}</Typography>
                        </Box>
                    </Box>} */}

                    {Array.isArray(latestBatchList) && latestBatchList?.length > 0 ? (
                        latestBatchList?.map((batch, index) => {
                            const isFirst = index === 0;
                            const id = batch?._id;

                            return (
                                <Box
                                    key={batch?._id}
                                    sx={{
                                        flex: 0,
                                        width: '100%',
                                        overflow: 'auto',
                                        mt: 1,
                                        border: isFirst
                                            ? batch.status === 'pending'
                                                ? '2px solid #ff0000ff'
                                                : '2px solid #078f07ff'
                                            : '#000000',
                                        background: isFirst
                                            ? batch.status === 'pending'
                                                ? '#ff000010'
                                                : '#078f0710'
                                            : '#f9f9f9',
                                        borderRadius: 1,
                                        p: 2,
                                        flexDirection: 'column',
                                        gap: 1.5,
                                    }}
                                    onClick={() => {
                                        getCsvBatchItemDetail(id);
                                    }}
                                >
                                    {/* Row 1 */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Typography variant="h5" fontWeight={800}>
                                            Batch Name: {batch?.batchName}
                                        </Typography>
                                        <Typography variant="h6" fontWeight={600}>
                                            Batch ID: {batch?._id}
                                        </Typography>
                                    </Box>

                                    {/* Row 2 */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            mt: 2
                                        }}
                                    >
                                        <Typography variant="h6" fontWeight={800}>
                                            Type: {batch?.type}
                                        </Typography>
                                        <Typography variant="h5" fontWeight={800}>
                                            Process Starts: {formatDateTime(batch?.created_at)}
                                        </Typography>
                                    </Box>

                                    {/* Row 3 */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            mt: 2
                                        }}
                                    >
                                        <Typography variant="h6" fontWeight={800}>
                                            Status: {batch.status}
                                        </Typography>
                                        <Typography variant="h6" fontWeight={600}>
                                            Process Last update: {formatDateTime(batch?.updated_at)}
                                        </Typography>
                                    </Box>

                                </Box>
                            );
                        })
                    ) : (
                        <Typography variant="h6" color="text.secondary">
                            No batches found
                        </Typography>
                    )}
                </Box>
            </Box>

            {mappedData && <JsonViewerDialog open={openViewJSONDialog} onClose={() => {
                setSelectedCSVType('');
                setMappedData([]);
                setOpenViewJSONDialog(false)
            }} jsonData={mappedData} />}
            {(specificBatchDetail && (specificCompletedBatches?.length > 0 || specificPendingBatches?.length > 0)) &&
                <BatchDetailsDialog
                    open={openBatchDetailsDialog}
                    onClose={() => {
                        setSpecificBatchDetail(null);
                        setSpecificCompletedBatches([]);
                        setSpecificPendingBatches([]);
                        getCsvBatchListApi();
                        setOpenBatchDetailsDialog(false);
                    }}
                    batchDetail={specificBatchDetail}
                    completedBatches={specificCompletedBatches}
                    pendingBatches={specificPendingBatches}
                    onDownloadSuccess={() => {
                        downloadCSV(specificCompletedBatches, `${specificBatchDetail?.batchName} (Success) - ${specificBatchDetail?._id}`)
                    }}
                    onDownloadFailed={() => {
                        downloadCSV(specificPendingBatches, `${specificBatchDetail?.batchName} (Failed) - ${specificBatchDetail?._id}`)
                    }}
                />}
            {loader && <Loader />}
            {folderUploading && (
                <UploadProgressLoader
                    open={folderUploading}
                    folderName={selectedFolderName}
                    totalFiles={totalFiles}
                    uploadedFiles={uploadedFiles}
                    currentFileName={currentFileName}
                    isUploading
                    title="Processing Rap Housie CSVs"
                />
            )}
        </>
    );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UploadCSV);